// Product catalog derived from the official Kruška Distribucija 2026 catalogue.
// Each category holds representative brands/products. Full range available in PDF.

export const CATALOG = [
  {
    id: "cokolade",
    icon: "Candy",
    accent: "#D4AF37",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/bqbc3mns_cokolada%20i%20konditorski%20proizvodi.png",
    name: { sr: "Čokolade i konditori", en: "Chocolate & Confectionery" },
    tagline: {
      sr: "Milka, Mars, Kinder, Ferrero, Nutella i najprodavaniji svetski brendovi.",
      en: "Milka, Mars, Kinder, Ferrero, Nutella and the best-selling global brands.",
    },
    products: [
      { name: "Milka Alpine Milk", pack: "100 g · 24 kom" },
      { name: "Milka Oreo", pack: "100 g · 22 kom" },
      { name: "Snickers", pack: "50 g · 40 kom" },
      { name: "Mars", pack: "47 g · 40 kom" },
      { name: "Twix", pack: "50 g · 30 kom" },
      { name: "Bounty", pack: "57 g · 24 kom" },
      { name: "Kinder Bueno", pack: "30 kom" },
      { name: "Kinder Chocolate", pack: "100 / 200 g" },
      { name: "Nutella", pack: "700 g" },
      { name: "Ferrero Rocher", pack: "200 g" },
      { name: "Raffaello", pack: "150 g / T4" },
      { name: "Toblerone", pack: "100 g" },
      { name: "Lion", pack: "42 g · 36 kom" },
      { name: "Bambi Plazma", pack: "75 / 150 g" },
      { name: "Jaffa Cakes", pack: "150 g" },
      { name: "Eurocrem blok", pack: "50 / 90 g" },
      { name: "Chupa Chups", pack: "vrteška 200 kom" },
      { name: "Mentos", pack: "38 g · svi ukusi" },
      { name: "Toffix / Coffex", pack: "300 g" },
      { name: "Fisherman's Friend", pack: "25 g · 24 kom" },
    ],
  },
  {
    id: "pica",
    icon: "CupSoda",
    accent: "#2E8B57",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/18ldxrrj_pica%20i%20energetska%20pica.png",
    name: { sr: "Pića i energetska pića", en: "Beverages & Energy" },
    tagline: {
      sr: "Bezalkoholna i energetska pića vodećih proizvođača.",
      en: "Soft drinks and energy drinks from leading producers.",
    },
    products: [
      { name: "Coca-Cola limenka", pack: "0,33 L" },
      { name: "Red Bull", pack: "0,25 L" },
      { name: "Guarana", pack: "0,25 L" },
      { name: "Ultra Energy", pack: "0,25 L" },
    ],
  },
  {
    id: "alkohol",
    icon: "Wine",
    accent: "#D4AF37",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/4ghrhocr_Alkoholna%20pica.png",
    name: { sr: "Alkoholna pića", en: "Spirits & Alcohol" },
    tagline: {
      sr: "Premium žestina — viski, vodka, gin, likeri i domaći program.",
      en: "Premium spirits — whisky, vodka, gin, liqueurs and local classics.",
    },
    products: [
      { name: "Jack Daniel's", pack: "0,7 / 1 L" },
      { name: "Chivas Regal", pack: "0,7 / 1 L" },
      { name: "Johnnie Walker Red / Black", pack: "0,7 / 1 L" },
      { name: "Ballantine's", pack: "0,7 / 1 L" },
      { name: "Jameson", pack: "0,7 / 1 L" },
      { name: "Jägermeister", pack: "0,7 / 1 L" },
      { name: "Smirnoff Vodka", pack: "0,7 / 1 L" },
      { name: "Grey Goose", pack: "0,7 L" },
      { name: "Beefeater Gin", pack: "0,7 / 1 L" },
      { name: "Olmeca / Sierra Tequila", pack: "1 L" },
      { name: "Gorki List", pack: "0,1 / 0,7 / 1 L" },
      { name: "Vinjak", pack: "0,1 L · 24 kom" },
    ],
  },
  {
    id: "kafa",
    icon: "Coffee",
    accent: "#2E8B57",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/iclld60j_kafa%20i%20instant%20napici.png",
    name: { sr: "Kafa i instant napici", en: "Coffee & Instant Drinks" },
    tagline: {
      sr: "Domaća i instant kafa, 3u1 programi i klasici.",
      en: "Domestic and instant coffee, 3-in-1 ranges and classics.",
    },
    products: [
      { name: "Grand Gold", pack: "100 / 200 g" },
      { name: "Grand Bonito / C kafa", pack: "100 / 200 g" },
      { name: "Nescafé Classic", pack: "2 / 20 / 250 g" },
      { name: "Ness 3u1 / 2u1", pack: "kutija 28 kom" },
      { name: "Mokate 3u1 / 2in1", pack: "24 kom / XXL" },
    ],
  },
  {
    id: "grickalice",
    icon: "Popcorn",
    accent: "#D4AF37",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/7glyzkd5_zvake%20i%20grickalice.png",
    name: { sr: "Žvake i grickalice", en: "Chewing Gum & Snacks" },
    tagline: {
      sr: "Žvake, slani i slatki snack asortiman za svaku policu.",
      en: "Chewing gum and sweet & savoury snacks for every shelf.",
    },
    products: [
      { name: "Orbit žvake", pack: "svi ukusi x10" },
      { name: "Airwaves", pack: "razni ukusi" },
      { name: "Pringles Original", pack: "165 g" },
      { name: "Pringles Hot & Spicy", pack: "165 g" },
      { name: "Pringles Cheese & Onion", pack: "165 g" },
      { name: "Halva vanila / kikiriki", pack: "30 / 270 g" },
      { name: "Bonžita žitarice", pack: "razni ukusi" },
    ],
  },
  {
    id: "higijena",
    icon: "SprayCan",
    accent: "#2E8B57",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/1kbsdglu_higijena%20i%20licna%20nega.png",
    name: { sr: "Higijena i lična nega", en: "Personal Care & Hygiene" },
    tagline: {
      sr: "Brijači, maramice i program lične nege.",
      en: "Razors, wipes and personal care range.",
    },
    products: [
      { name: "Gillette Blue / Mach3", pack: "blister" },
      { name: "BIC brijači / žileti", pack: "1/5" },
      { name: "Labello", pack: "4,8 g" },
      { name: "Camelia maramice", pack: "papirne / vlažne" },
      { name: "Hansaplast", pack: "30 kom" },
    ],
  },
  {
    id: "domacinstvo",
    icon: "Lightbulb",
    accent: "#D4AF37",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/4dwj7to1_Domacinstvo%20i%20kancelarija.png",
    name: { sr: "Domaćinstvo i kancelarija", en: "Household & Office" },
    tagline: {
      sr: "Baterije, sijalice, fiskalne rolne, kese i sitna roba.",
      en: "Batteries, bulbs, receipt rolls, bags and everyday essentials.",
    },
    products: [
      { name: "Duracell baterije", pack: "AAA / AA / 9V" },
      { name: "Panasonic baterije", pack: "R3 / R6 / R20" },
      { name: "LED sijalice ECO", pack: "5W / 9W" },
      { name: "Fiskalne termo rolne", pack: "57/40 · 79/60" },
      { name: "Plastične kese tregerice", pack: "1/1000" },
      { name: "Super lepak / OHO", pack: "3 / 20 g" },
      { name: "Hemijske olovke", pack: "50 kom" },
    ],
  },
  {
    id: "duvanski",
    icon: "Flame",
    accent: "#2E8B57",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/bwj7ljc5_Duvanski%20pribor.png",
    name: { sr: "Duvanski pribor", en: "Smoking Accessories" },
    tagline: {
      sr: "Papirići, filteri, mašinice, upaljači i Zippo program.",
      en: "Papers, filters, machines, lighters and Zippo range.",
    },
    products: [
      { name: "Flarus tube / filteri", pack: "1/200 · 1/600" },
      { name: "Smoking papirići", pack: "No.8 / KS De Luxe" },
      { name: "Smoking mašinice", pack: "auto 70/78 mm" },
      { name: "Zippo benzin / kremen", pack: "125 ml" },
      { name: "Cricket upaljači", pack: "Fusion / Simplicity" },
      { name: "BIC upaljači", pack: "—" },
    ],
  },
  {
    id: "ostalo",
    icon: "Sparkles",
    accent: "#D4AF37",
    image:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/67147i2r_Ostalo%20i%20sezonska%20roba.png",
    name: { sr: "Ostalo i sezonska roba", en: "Other & Seasonal" },
    tagline: {
      sr: "Osveživači, čestitke, kocke za potpalu i sezonski program.",
      en: "Air fresheners, greeting cards, firelighters and seasonal goods.",
    },
    products: [
      { name: "Areon osveživači", pack: "Smile / Lux / Fresco" },
      { name: "Fresh room", pack: "250 ml + dopune" },
      { name: "Čestitke 3D Lux", pack: "12,3 × 18,4 cm" },
      { name: "Flame kocke za potpalu", pack: "26 kom" },
      { name: "Sprej protiv insekata", pack: "400 ml" },
    ],
  },
];

// Partner brands for the marquee
export const BRANDS = [
  "Milka", "Mars", "Kinder", "Ferrero", "Nutella", "Coca-Cola", "Red Bull",
  "Pringles", "Nescafé", "Grand", "Jack Daniel's", "Chivas Regal",
  "Jägermeister", "Orbit", "Gillette", "Mentos", "Chupa Chups", "Toblerone",
  "Bambi", "Štark", "Smirnoff", "Ballantine's",
];
